export default __webpack_public_path__ + "media/images/email-fb843a1d9a74d36512cfe7e6c943136b.svg";